<template>
  <v-container fluid style="max-width: 1280px;">
    <v-layout alig-start>
      <v-flex>
        <!-- Inicio de barra de alerta -->
        <v-snackbar v-model="alerta.snackbar" :color="alerta.color" @click="alerta.snackbar = false">{{ alerta.text
          }}</v-snackbar>
        <!-- Fin inicio de barra de alerta -->

        <!-- Listado de tipo bien y opciones de titulo, busqueda, nuevo, etc -->
        <v-data-table :loading="loading" :headers="cabTBien" :items="tipoBienes" :items-per-page="15" :search="buscar"
          class="elevation-3" dense>
          <template v-slot:top>
            <v-toolbar flat>
              <v-toolbar-title class="hidden-sm-and-down">TIPO BIENES</v-toolbar-title>
              <v-divider class="mx-4 hidden-sm-and-down" inset vertical></v-divider>
              <!-- Impresion tipo bien -->
              <v-btn text fab x-small color="accent" @click="crearPDF()" class="mr-1">
                <v-icon>description</v-icon>
              </v-btn>
              <!-- Fin Impresion tipo bien -->

              <v-spacer />
              <!-- Formulario busqueda de tipo bien -->
              <v-text-field class="text-xs-center" v-model.trim="buscar" @keyup="listar()" append-icon="search" dense
                label="Búsqueda" hide-details></v-text-field>
              <!-- Fin Formulario Busqueda de tipo bien -->
              <v-spacer />
              <!-- Modal crear y modificar tipo bien -->
              <v-dialog v-model="dialog" max-width="600px" persistent>
                <template v-slot:activator="{ on }">
                  <v-btn fab x-small dark color="primary" v-on="on">
                    <v-icon dark>add</v-icon>
                  </v-btn>
                </template>
                <v-card>
                  <v-toolbar dark dense class="primary">
                    <v-toolbar-title>{{ formTitle }}</v-toolbar-title>
                    <v-spacer />
                    <v-btn icon dark @click="guardar" :loading="desabilitar" :disabled="desabilitar || !isValid">
                      <v-icon>save</v-icon>
                    </v-btn>
                    <v-btn icon dark @click="close">
                      <v-icon>close</v-icon>
                    </v-btn>
                  </v-toolbar>
                  <v-card-text>
                    <v-form v-model="isValid">
                      <v-row class="mt-2">
                        <v-col cols="12" sm="3">
                          <v-text-field dense v-model.trim="codtipobien" label="Cod. Tipo Bien"
                            :rules="[v => v.length == 8 || 'requerido', Rules.unespacio]" maxlength="8"
                            :disabled="editedIndex == 1" v-mask-number v-uppercase hide-details></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="9">
                          <v-text-field dense v-model.trim="descripcion" label="Descripción"
                            :rules="[v => !!v || 'requerido', Rules.unespacio]" maxlength="60" v-uppercase
                            hide-details></v-text-field>
                        </v-col>
                        <!-- Mensaje error tipo bien -->
                        <v-col cols="12" v-if="mensajeTipo != ''">
                          <v-alert text dense type="error">{{ mensajeTipo }}</v-alert>
                        </v-col>
                        <!-- Mensaje error tipo bien -->
                      </v-row>
                    </v-form>
                  </v-card-text>
                </v-card>
              </v-dialog>
              <!-- Fin Modal crear y modificar tipo bien -->

              <!-- Modal activar, desactivar tipo bien -->
              <v-dialog v-model="adModal" max-width="400">
                <v-card>
                  <v-card-title class="headline justify-center" v-if="adAccion == 1">¿Activar Tipo Bien?</v-card-title>
                  <v-card-title class="headline justify-center" v-if="adAccion == 2">¿Desactivar Tipo
                    Bien?</v-card-title>
                  <v-card-text>
                    Estás a punto de
                    <span v-if="adAccion == 1">Activar</span>
                    <span v-if="adAccion == 2">Desactivar</span>
                    el tipo bien {{ adId + " " + adNombre }}
                  </v-card-text>
                  <v-card-actions class="py-0 pb-4 justify-center">
                    <v-btn text x-small color="error" @click="activarDesactivarCerrar">Cancelar</v-btn>
                    <v-btn v-if="adAccion == 1" text x-small color="success" @click="activar">Activar</v-btn>
                    <v-btn v-if="adAccion == 2" text x-small color="warning" @click="desactivar">Desactivar</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
              <!-- Fin Modal activar, desactivar tipo bien -->
            </v-toolbar>
          </template>
          <!-- Opciones editar, eliminar tipo bien -->

          <template v-slot:item.condicion="{ item }">
            <template v-if="item.condicion">
              <v-btn text x-small color="success" @click="activarDesactivarMostrar(2, item)">Activo</v-btn>
            </template>
            <template v-else>
              <v-btn text x-small color="warning" @click="activarDesactivarMostrar(1, item)">Inactivo</v-btn>
            </template>
          </template>

          <template v-slot:item.opciones="{ item }">
            <v-btn x-small icon>
              <v-icon color="info" @click="editItem(item)">edit</v-icon>
            </v-btn>
            <v-btn x-small icon v-if="esSuperadministrador">
              <v-icon color="error" @click="deleteItem(item)">delete_forever</v-icon>
            </v-btn>
          </template>
          <!-- Fin Opciones editar, eliminar tipo bien -->
        </v-data-table>
        <!-- Fin Listado de tipo bien y opciones de titulo, busqueda, nuevo, etc -->
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import axios from "axios";
import jsPDF from "jspdf";
import { mapState, mapGetters } from "vuex";

export default {
  data() {
    return {
      tipoBienes: [],
      dialog: false,
      cabTBien: [
        { text: "Cod. Tipo Bien", value: "codtipobien", sortable: false },
        { text: "Descripcion", value: "descripcion", sortable: false },
        { text: "Condición", align: "center", value: "condicion", sortable: false },
        { text: "OPC.", value: "opciones", sortable: false },
      ],

      buscar: "",
      editedIndex: -1,
      codtipobien: "",
      descripcion: "",

      adModal: 0,
      adAccion: 0,
      adNombre: "",
      adId: "",
      mensajeTipo: "",

      desabilitar: false,
      isValid: true,
      alerta: { snackbar: false, color: "", text: "" },

      Rules: {
        unespacio: (v) =>
          (v || "").indexOf("  ") < 0 || "No se permite mas de 1 espacio",
      },
    };
  },

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Nuevo Tipo Bien" : "Actualizar Tipo Bien";
    },
    ...mapState(["usuarioState", "empresaState"]),
    ...mapGetters(["esSuperadministrador"]),
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  created() {
    this.listar();
  },

  methods: {
    /* Listar tipo bien */
    listar() {
      let me = this;
      me.loading = true;

      axios
        .get("api/Tipobienes/ListarTipoBienFiltro", {
          params: {
            buscar: me.buscar == "" ? "-" : me.buscar,
          },
        })
        .then(function (response) {
          me.tipoBienes = response.data;
          me.loading = false;
        })
        .catch((err) => {
          //console.log(err.response);
        });
    },
    /* Fin Listar tipo bien */

    /* Editar y guardar tipo bien */
    guardar() {
      let me = this;
      me.desabilitar = true;

      if (me.editedIndex > -1) {
        //Código para editar
        axios
          .put("api/Tipobienes/Actualizar", {
            codtipobien: me.codtipobien,
            descripcion: me.descripcion,
          })
          .then(function (response) {
            me.desabilitar = false;
            me.alerta.snackbar = true;
            me.alerta.color = "success";
            me.alerta.text = response.data;
            me.close();
            me.listar();
            me.limpiar();
          })
          .catch(function (error) {
            me.desabilitar = false;
            me.mensajeTipo = error.response.data;
            me.limpiarAlertaError();
          });
      } else {
        //Código para guardar
        axios
          .post("api/Tipobienes/Crear", {
            codtipobien: me.codtipobien,
            descripcion: me.descripcion,
          })
          .then(function (response) {
            me.desabilitar = false;
            me.alerta.snackbar = true;
            me.alerta.color = "success";
            me.alerta.text = response.data;
            me.close();
            me.listar();
            me.limpiar();
          })
          .catch(function (error) {
            me.desabilitar = false;
            me.mensajeTipo = error.response.data;
            me.limpiarAlertaError();
          });
      }
    },
    /* Fin Editar y guardar tipo bien */

    /* Limpiar mensaje tipo bien */
    limpiarAlertaError() {
      setTimeout(() => {
        this.mensajeTipo = "";
      }, 3000);
    },
    /* Fin Limpiar mensaje tipo bien */

    /* Editar tipo bien item */
    editItem(item) {
      this.codtipobien = item.codtipobien;
      this.descripcion = item.descripcion;
      this.editedIndex = 1;
      this.dialog = true;
    },
    /* Fin Editar tipo bien item */

    /* Cerrar ventana tipo bien */
    close() {
      this.dialog = false;
      this.limpiar();
    },
    /* Fin Cerrar ventana tipo bien */

    /* Limpiar tipo bien item */
    limpiar() {
      this.codtipobien = "";
      this.descripcion = "";
      this.mensajeTipo = "";
      this.editedIndex = -1;
    },
    /* Fin Limpiar tipo bien item */

    /* Desactivar, activar tipo bien */
    desactivar() {
      let me = this;

      axios
        .put("api/Tipobienes/Desactivar/" + this.adId, {})
        .then(function (response) {
          me.adModal = 0;
          me.adAccion = 0;
          me.adNombre = "";
          me.adId = "";
          me.listar();
        })
        .catch(function (error) {
          //console.log(error);
        });
    },

    activarDesactivarMostrar(accion, item) {
      this.adModal = 1;
      this.adNombre = item.descripcion;
      this.adId = item.codtipobien;
      if (accion == 1) {
        this.adAccion = 1;
      } else if (accion == 2) {
        this.adAccion = 2;
      } else {
        this.adModal = 0;
      }
    },

    activarDesactivarCerrar() {
      this.adModal = 0;
    },

    activar() {
      let me = this;
      axios
        .put("api/Tipobienes/Activar/" + this.adId, {})
        .then(function (response) {
          me.adModal = 0;
          me.adAccion = 0;
          me.adNombre = "";
          me.adId = "";
          me.listar();
        })
        .catch(function (error) {
          //console.log(error);
        });
    },
    /* Fin Desactivar, activar tipo bien */

    /* Eliminar tipo bien */
    deleteItem(item) {
      const respta = confirm(
        "¿Estás seguro de que deseas eliminar el tipo bien " + item.descripcion + "?"
      );
      if (respta) {
        let me = this;
        axios
          .delete("api/Tipobienes/Eliminar/" + item.codtipobien)
          .then((response) => {
            me.alerta.snackbar = true;
            me.alerta.color = "success";
            me.alerta.text = response.data;
            this.listar();
          })
          .catch(function (error) {
            me.alerta.snackbar = true;
            me.alerta.color = "error";
            me.alerta.text = error.response.data;
          });
      }
    },
    /* Fin Eliminar tipo bien */

    /* Crear PDF tipo bien */
    crearPDF() {
      var columns = [
        { header: "C. Tipo Bien", dataKey: "codtipobien" },
        { header: "Descripción", dataKey: "descripcion" },
        { header: "Condicion", dataKey: "condicion" },
      ];
      var body = [];

      this.tipoBienes.map(function (x) {
        body.push({
          descripcion: x.descripcion,
          codtipobien: x.codtipobien,
          condicion: x.condicion == 1 ? "Activo" : "Inactivo",
        });
      });
      //console.log(body);
      // Agregar Encabezado: titulo y logo
      const addHeaders = (doc) => {
        const pageCount = doc.internal.getNumberOfPages();

        doc.setFont("helvetica", "bold");
        doc.setFontSize(10);
        for (var i = 1; i <= pageCount; i++) {
          doc.setPage(i);
          doc.text("LISTADO DE TIPO DE BIENES", doc.internal.pageSize.width / 2, 45, {
            align: "center",
          });
          doc.addImage(imgData, "JPEG", 40, 17, 35, 40);
        }
      };
      // Agregar pie de pagina: numeración
      const addFooters = (doc) => {
        const pageCount = doc.internal.getNumberOfPages();

        doc.setFont("helvetica", "italic");
        doc.setFontSize(7);
        for (var i = 1; i <= pageCount; i++) {
          doc.setPage(i);
          doc.text(
            "Pagina " + String(i) + " de " + String(pageCount),
            doc.internal.pageSize.width / 2,
            820,
            {
              align: "center",
            }
          );
        }
      };

      // Configurando hoja
      var imgData = "data:image/png;base64," + this.empresaState.logo;
      var doc = new jsPDF("p", "pt");

      doc.autoTable({
        columns,
        body,
        margin: { top: 70 },
        headStyles: {
          fillColor: [46, 78, 121],
          fontSize: 7,
          halign: "center",
        },
        bodyStyles: { textColor: 0, fontSize: 8 },
        columnStyles: {
          codtipobien: { cellWidth: 50 },
          descripcion: { cellWidth: "auto", },
          condicion: { cellWidth: 45.28, halign: "center" },
        },
      });
      // 515 ancho hoja
      addHeaders(doc);
      addFooters(doc);
      doc.save("TipoBienes.pdf");
    },
    /* Fin Crear PDF tipo bien */
  },
};
</script>
